import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../cn.js';
export function Card({ className, ...rest }) {
    return (_jsx("div", { className: cn('rounded-lg border border-surface-container-high bg-surface-container-lowest shadow-sm', className), ...rest }));
}
export function CardHeader({ className, children }) {
    return (_jsx("div", { className: cn('border-b border-surface-container px-5 py-4', className), children: children }));
}
export function CardBody({ className, children }) {
    return _jsx("div", { className: cn('px-5 py-4', className), children: children });
}
export function CardFooter({ className, children }) {
    return (_jsx("div", { className: cn('border-t border-surface-container px-5 py-4 flex items-center justify-end gap-2', className), children: children }));
}
//# sourceMappingURL=Card.js.map